import { AUTH_STATES } from '/b2b/authentication/constants';
import AuthActions from '/b2b/authentication/state/Auth.actions';
import { resetPassword as ResetPasswordService } from '/b2b/authentication/services';
import { shouldRemember } from '/b2b/authentication/state/Auth.selectors';
import { signIn } from '/b2b/authentication/routes/SignIn/SignIn/SignIn.commands';

export const resetAuthState = () => dispatch =>
    dispatch(AuthActions.updateAuthState(AUTH_STATES.signedOut));

export const onResetPassword =
    ({ newPassword, username, code }) =>
    (dispatch, getState) => {
        const params = { password: '--REDACTED--', username, code };
        const state = getState();
        const rememberMe = shouldRemember(state);
        dispatch(AuthActions.resetPasswordBegin(params));
        return ResetPasswordService({ newPassword, username, confirmationCode: code })
            .then(() => {
                dispatch(AuthActions.resetPasswordSuccess(params));
                // When you reset your password, you are not OFFICIALLY logged in
                return dispatch(signIn({ username, password: newPassword, rememberMe }));
            })
            .catch(error => {
                const { message } = error;
                dispatch(AuthActions.resetPasswordFailure(params, message));
                throw message;
            });
    };
